import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { toFixedIfFloat } from 'utils/helpers';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.cultures || initialState;

export const selectCultures = createSelector([selectSlice], state => state);

export const selectCultureDetailsCultureId = createSelector(
  [selectCultures],
  state => state.cultureDetails.culturesArr[0]?.culture.id,
);

export const selectAllCultures = createSelector([selectCultures], state =>
  [...state.cultures].sort((a, b) => a.name.localeCompare(b.name)),
);

export const selectCulturesLoading = createSelector(
  [selectCultures],
  state => state.loading,
);

export const selectCulturesListLoading = createSelector(
  [selectCultures],
  state => state.culturesList.loading,
);

export const selectListCultures = createSelector([selectCultures], state => {
  return state.culturesList.cultures.cultures;
});

export const selectCompaniesCultures = createSelector(
  [selectCultures],
  state => {
    return state.culturesList.cultures.companies;
  },
);

export const selectCultureDetails = createSelector(
  [selectCultures],
  state => state.cultureDetails,
);

export const selectCultureDetailsCulturesArr = createSelector(
  [selectCultures],
  state => state.cultureDetails.culturesArr,
);

export const selectCreateCompanyLoading = createSelector(
  [selectCultures],
  state => state.createCulture.loading,
);

export const selectCultureFieldsTotalArea = createSelector(
  [selectCultures],
  state =>
    toFixedIfFloat(
      state.cultureDetails.culturesArr.reduce(
        (accumulator, companyCultureItem) => {
          return (accumulator += companyCultureItem.area);
        },
        0,
      ),
    ),
);
